import { render, staticRenderFns } from "./ModalGroupAccept.vue?vue&type=template&id=487c368c&scoped=true"
import script from "./ModalGroupAccept.vue?vue&type=script&lang=js"
export * from "./ModalGroupAccept.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupAccept.vue?vue&type=style&index=0&id=487c368c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c368c",
  null
  
)

export default component.exports